import axios from 'axios';
import qs from 'qs';
import { message } from 'ant-design-vue';
import { BASE_URL, CODE, MESSAGE } from '@/config/http.config';
import { getSearchObj } from '@/utils/common';

const http = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  transformRequest: [data => qs.stringify(data)],
  // withCredentials: true,
});

http.interceptors.request.use((config) => {
  const { ticket } = getSearchObj(window.location.search.slice(1));

  if (ticket) {
    const { origin, pathname } = window.location;
    window.history.replaceState(null, null, `${origin}${pathname}`);
    config.params.ticket = ticket;
  }

  return config;
});

http.interceptors.response.use((response) => {
  const { code, msg, data } = response.data;

  switch (code) {
    case CODE.SUCCESS:
      return response.data;

    case CODE.UNAUTHORIZED:
      window.location.href = data;
      message.error(MESSAGE.UNAUTHORIZED);
      break;

    case CODE.FORBIDDEN:
      message.error(MESSAGE.FORBIDDEN);
      break;

    default:
      message.error(msg || MESSAGE.DEFAULT);
      break;
  }

  return Promise.reject();
});

export default http;
